import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2, RendererFactory2, signal } from "@angular/core";
import { APP_SETTINGS, IAppSettings, IBrandSettings } from "./settings";

@Injectable({
    providedIn: 'root'
})
export class SettingService {

    public static readonly CURRENT_YEAR = new Date().getFullYear();

    public readonly appSettings: IAppSettings = {
        dateFormat: 'yyyy-MM-dd',
        parts24LoginLink: 'https://www.partslink24.com/partslink24/index.jsp',
        parts24HeaderLink: 'https://selfattend.amigosdopartslink.com/'
    }

    private readonly bmw: IBrandSettings = {
        name: "BMW",
        privacyPolicyLink: 'https://login.bmwusa.com/pm2/pm-document-service/api/v1link/documents/policyName/MY_BMW_APP_DPP/US/PDF?language=en&KeyId=dbf0a542-ebd1-4ff0-a9a7-55172fbfce35',
        copyright: `© ${SettingService.CURRENT_YEAR} BMW OF NORTH AMERICA, LLC. ALL RIGHTS RESERVED`,
        videoThumbnail: 'assets/images/bmw-logo.png',
    }

    private readonly mini: IBrandSettings = {
        name: "MINI",
        privacyPolicyLink: 'https://login.bmwusa.com/pm2/pm-document-service/api/v1link/documents/policyName/MINI_APP_DPP/US/PDF?language=en&KeyId=dbf0a542-ebd1-4ff0-a9a7-55172fbfce35',
        copyright: `© ${SettingService.CURRENT_YEAR} MINI USA, a division of BMW of North America, LLC. All Rights Reserved`,
        videoThumbnail: 'assets/images/MINI_symbol_RGB_black_30px.png',
    }

    private readonly rollsRoyce: IBrandSettings = {
        name: "ROLLSROYCE",
        privacyPolicyLink: 'https://www.rolls-roycemotorcars.com/en_US/information/privacy-policy.html',
        copyright: `The copyrights and trademarks, including names, logos, and images, contained in this website belong to Rolls-Royce Motor Cars NA, LLC. No person may copy, modify, transmit, distribute, display, reproduce, publish, license or create works from any part of this material or otherwise use it for any public or commercial use without the prior express written permission of Rolls-Royce Motor Cars NA, LLC. Nothing contained in this website shall be deemed to confer any right, title, or license to any such copyright or trademark of Rolls-Royce Motor Cars NA, LLC.`,
        videoThumbnail: 'assets/images/RR_Small_Logo_Black.png',
    }

    private readonly motorrad: IBrandSettings = {
        ...this.bmw,
        name: "MOTORRAD",
        privacyPolicyLink: 'https://my.bmwmotorcycles.com/privacypolicy',
        copyright: `© ${SettingService.CURRENT_YEAR} MOTORRAD USA, a division of BMW of North America, LLC. All Rights Reserved`
    }

    private legacyAppSettings: any
    private readonly renderer: Renderer2;
    private readonly brandSettingsSignal = signal<IBrandSettings>(this.bmw);
    public readonly brandSettings = this.brandSettingsSignal.asReadonly();

    constructor(
        rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) private readonly document: Document
    ) {
        this.legacyAppSettings = APP_SETTINGS
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    getAppSettings() {
        return { ...this.appSettings }
    }

    updateActiveSettings(settings: any) {
        this.legacyAppSettings = settings ?? APP_SETTINGS;
        let activeBrand: IBrandSettings;

        if (this.legacyAppSettings.isMOTORRAD === 'true') {
            activeBrand = this.motorrad
        }
        else if (this.legacyAppSettings.isBMW === 'true') {
            activeBrand = this.bmw
        }
        else if (this.legacyAppSettings.isMINI === 'true') {
            activeBrand = this.mini
        }
        else if (this.legacyAppSettings.isRollsRoyce === 'true') {
            activeBrand = this.rollsRoyce
        }

        this.brandSettingsSignal.set(activeBrand);
        console.log(`Active Brand: ${activeBrand?.name}`);
        this.renderer.addClass(this.document.body, activeBrand?.name?.toLowerCase());
    }
}
